import {
    Directive,
    ElementRef,
    HostListener,
    Input
} from '@angular/core';
@Directive({
    selector: '[appDecimalvaliation]',
    standalone: false
})
export class DecimalvalidaitonDirective {
    private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
    private nonZeroRegex: RegExp = new RegExp(/^[1-9]\d*$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
    @Input() allowZero = true;
    constructor(private el: ElementRef) {}
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
        if (next && (this.allowZero ? !String(next).match(this.regex) : !String(next).match(this.nonZeroRegex))) {
            event.preventDefault();
        }
    }
}
